import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Header')(
  css({
    width: ['100vw', 'auto', 'auto'],
    py: ['16px', '16px', '24px'],
    px: ['20px', '20px', '48px'],
    backgroundColor: 'red',
  }),
);

themeStyles.addBaseStyles('ModalTitleWrapper')(
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    color: 'white',
    fontWeight: '500 !important',
    fontFamily: ['bold', 'bold', 'heading'],
    fontSize: ['20px', '20px', '44px'],
    lineHeight: ['24px', '24px', '50px'],
  }),
);

themeStyles.addBaseStyles('Description')(
  css({
    mt: ['0', '0', 'xs'],
    color: 'white',
    fontSize: ['14px', '14px', '16px'],
    lineHeight: ['22px', '22px', '26px'],
    width: '100%',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    width: '45px',
    height: '45px',
    mr: '-12px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Container')(({ width = ['100vw', '100vw', '100%'] }) =>
  css({
    width,
    py: ['24px', '24px', '56px'],
    px: ['0', '0', '48px'],
    backgroundColor: 'white',
    overflowY: ['hidden', 'hidden', 'auto'],
    overflowX: 'hidden',
  }),
);

themeStyles.addBaseStyles('LocationWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '32px',
    py: '24px',
  }),
);

themeStyles.addBaseStyles('LocationText')(
  css({
    fontSize: ['14px', '14px', '16px'],
    lineHeight: ['22px', '22px', '26px'],
    color: 'blackSolidShades.2',
    padding: 'm',
    textAlign: 'center',
  }),
);

themeStyles.addBaseStyles('StyledButton')(({ width = '100%' }) =>
  css({
    width,
    minWidth: 'auto',
  }),
);

themeStyles.addBaseStyles('ErrorWrapper')(
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '44px',
    gap: '4px',
  }),
);

export default themeStyles;
